/** One row of a list: an item on its own, or back-to-back items that share a key folded together. */
export type Folded<Item> = { kind: "one"; item: Item } | { kind: "run"; items: [Item, ...Item[]] };

/**
 * Folds back-to-back items with the same key into runs. An item without a key stays on its own, and
 * with `expandAll` every item does.
 */
export function foldRuns<Item>(
  items: readonly Item[],
  key: (item: Item) => string | undefined,
  expandAll: boolean,
): Folded<Item>[] {
  const rows: Folded<Item>[] = [];
  let index = 0;
  while (index < items.length) {
    const first = items[index] as Item;
    const runKey = expandAll ? undefined : key(first);
    let end = index + 1;
    while (runKey && end < items.length && key(items[end] as Item) === runKey) end += 1;
    rows.push(
      end - index > 1
        ? { kind: "run", items: [first, ...items.slice(index + 1, end)] }
        : { kind: "one", item: first },
    );
    index = end;
  }
  return rows;
}
